export const FETCH_GOAL_DATABANKS = 'FETCH_GOAL_DATABANKS';
export const CREATE_GOAL_DATABANK = 'CREATE_GOAL_DATABANK';
export const GET_GOAL_DATABANK = 'GET_GOAL_DATABANK';
export const UPDATE_GOAL_DATABANK = 'UPDATE_GOAL_DATABANK';
export const DELETE_GOAL_DATABANK = 'DELETE_GOAL_DATABANK';
export const FETCH_STAFF_GOAL_DATABANKS = 'FETCH_STAFF_GOAL_DATABANKS';
export const CREATE_STAFF_GOAL_DATABANK = 'CREATE_STAFF_GOAL_DATABANK';
export const GET_STAFF_GOAL_DATABANK = 'GET_STAFF_GOAL_DATABANK';
export const DELETE_STAFF_GOAL_DATABANK = 'DELETE_STAFF_GOAL_DATABANK';
export const UPDATE_STAFF_GOAL_DATABANK = 'UPDATE_STAFF_GOAL_DATABANK';